import SurfaceObsWeatherData from '../interfaces/surfaceObs'

interface SurfaceObsParsedData {
  latitude: number
  longitude: number
  properties?: { [key: string]: any }
}

export function SurfaceObsAPIParser(apiresponse: SurfaceObsWeatherData, elevatedobs = false) {
  const parsedArray: SurfaceObsParsedData[] = []
  apiresponse?.features?.forEach((feature) => {
    const newObject: SurfaceObsParsedData = {
      latitude: feature.geometry.coordinates[1],
      longitude: feature.geometry.coordinates[0],
      properties: feature.properties,
    }
    if(elevatedobs) newObject["elevated"] = true 
    parsedArray.push(newObject)
  })
  return parsedArray
}

// Function to extract unique SensorType values
export function getUniqueSensorTypes(data: any, alertInfo : any): [boolean, string[]] {
  const uniqueSensorTypes = new Set<string>()
  let alertLabelFound = false
  data?.forEach((feature: any) => {
    const sensorType = feature?.properties?.SensorType?.value
    const sensorId = feature?.properties?.StationID?.value
    let sensorIdentifier = sensorType + '-' + sensorId
    uniqueSensorTypes.add(sensorType)
    if(sensorIdentifier in alertInfo) alertLabelFound = true
  })    
  Array.from(new Set(uniqueSensorTypes))
  return [alertLabelFound, Array.from(new Set(uniqueSensorTypes))]
}
